import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/feature/details/feature.details.featureTranslation.query.gql"
import type {
  FeatureDetailsTranslationQuery,
  FeatureDetailsTranslationQueryVariables,
} from "@/v2-backoffice-client/feature/details/__types__/feature.details.featureTranslation.query"

type Options = QueryHookOptions<
  FeatureDetailsTranslationQuery,
  FeatureDetailsTranslationQueryVariables
>

export function useFeatureDetailsTranslationQuery(options?: Options) {
  return useQuery<
    FeatureDetailsTranslationQuery,
    FeatureDetailsTranslationQueryVariables
  >(query, options)
}
